import { render, staticRenderFns } from "./ResumenBusqueda.vue?vue&type=template&id=b145d044&scoped=true"
import script from "./ResumenBusqueda.vue?vue&type=script&lang=js"
export * from "./ResumenBusqueda.vue?vue&type=script&lang=js"
import style0 from "./ResumenBusqueda.vue?vue&type=style&index=0&id=b145d044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b145d044",
  null
  
)

export default component.exports